"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTreemapConfiguration = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var TREEMAP_TEMPLATE = {
    chart: {
        type: "treemap",
        margin: [0, 0, 5, 0],
    },
    plotOptions: {
        treemap: {
            showInLegend: true,
            borderColor: "white",
            layoutAlgorithm: "squarified",
            dataLabels: {
                enabled: true,
                allowOverlap: false,
            },
            levels: [
                {
                    level: 1,
                    dataLabels: {
                        enabled: true,
                        allowOverlap: false,
                    },
                },
                {
                    level: 2,
                    dataLabels: {
                        enabled: true,
                        allowOverlap: false,
                    },
                },
            ],
            point: {
                events: {
                    // from Highcharts 5.0.0 cursor can be set by using 'className' for individual data items
                    mouseOver: function () {
                        if (this.drilldown) {
                            this.graphic.element.style.cursor = "pointer";
                        }
                    },
                },
            },
        },
    },
    legend: {
        enabled: false,
    },
};
function getTreemapConfiguration() {
    return cloneDeep_1.default(TREEMAP_TEMPLATE);
}
exports.getTreemapConfiguration = getTreemapConfiguration;
//# sourceMappingURL=treemapConfiguration.js.map